import * as Immutable from "immutable"

import { AbstractConfigurationMessage } from "./abstractConfigurationMessage"
import { VariableInfo } from ".."

export class WarningVariablesMessage extends AbstractConfigurationMessage {

  protected readonly VARIABLE_INFOS = "variableInfos";

  get variableInfos(): Immutable.List<VariableInfo> { return this.getInternalValue<Immutable.List<VariableInfo>>(this.VARIABLE_INFOS); }
  setVariableInfos(variableInfos: Immutable.List<VariableInfo>): this { return this.setInternalValue(this.VARIABLE_INFOS, variableInfos); }
}